<template>
  <div>
    <div v-if="!this.$route.params.id" class="text-h6" style="margin: 20px">New Organization</div>
    <div v-else class="text-h6" style="margin: 20px">Update Organization</div>
    <v-card olor="grey lighten-4" style="margin: 20px">
      <v-card-text>
        <v-text-field v-model="name" label="Name" :rules="[textfieldRules.required]"></v-text-field>
        <v-text-field v-model="governor" label="Governor" :rules="[textfieldRules.required]"></v-text-field>
        <div class="text-subtitle-2">Upload image</div>

        <v-file-input
          id="imageInput"
          @change="onFileChange"
          label="Logo image"
          v-model="imageFile"
          style="display: none"
        ></v-file-input>
        <v-row id="imageRow">
          <v-col>
            <img
              v-if="this.hasImage"
              :src="this.image"
              id="image"
              alt="Logo image"
              style="width: 60%; min-width: 100px"
            />
            <v-icon size="80" v-else>mdi-image</v-icon>
          </v-col>
          <v-col>
            <v-btn style="margin: 10%" elevation="0" @click="this.imageAction">
              {{ this.hasImage ? 'Delete picture' : 'Add picture' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <div class="text-subtitle-1" style="color: red; margin-left: 10px">{{ this.errorText }}</div>
      <div class="ml-2">
        <v-btn @click="saveAndExit()" style="margin: 20px">
          <div>Save and exit</div>
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
  import { GET_ORGANIZATIONS, ADD_OR_UPDATE_ORGANIZATION } from '../../../graphql/organizationQueries';
  import { toBase64 } from '../../../utils/Helper.js';

  export default {
    created() {
      this.populateData();
    },
    data() {
      return {
        name: '',
        governor: '',
        imageFile: null,
        image: null,
        jsonData: {},
        organization: null,
        errorText: '',
        textfieldRules: {
          required: (value) => !!value || 'required field',
        },
      };
    },
    apollo: {
      $client: 'organizationClient',
    },
    computed: {
      hasImage: function () {
        return this.imageFile != null;
      },
    },
    methods: {
      async populateData() {
        const id = this.$route.params.id;
        if (id) {
          this.organization = await this.$apollo
            .query({
              query: GET_ORGANIZATIONS,
              client: 'organizationClient',
              variables: {
                id: id,
              },
            })
            .then((response) => {
              const result = response.data.getOrganizations;
              if (result.length > 0) return result[0];
              return null; // Query returns an array, we take first element since we use specific ID
            })
            .catch((error) => {
              throw error;
            });
          if (this.organization) {
            this.name = this.organization.name;
            this.governor = this.organization.governorOrganizationId;
            this.jsonData = this.organization.jsonData;
            this.image = this.organization.image;
            if (this.image) {
              fetch(this.image)
                .then((res) => res.blob())
                .then((blob) => {
                  this.imageFile = new File([blob], 'name', { type: 'image/png' });
                });
            }
          }
        }
      },
      async saveAndExit() {
        try {
          //Validate form
          if (this.name == '' || this.governor == '') {
            this.errorText = 'Please fill in all required fields.';
            return;
          }
          let base64Image = null;
          if (this.imageFile) {
            base64Image = await toBase64(this.imageFile);
          }
          let organizationJson = {
            name: this.name,
            governorOrganizationId: this.governor,
            image: base64Image,
            jsonData: this.jsonData,
          };

          if (this.$route.params.id) {
            organizationJson.id = this.$route.params.id;
          }

          const result = await this.$apollo.mutate({
            mutation: ADD_OR_UPDATE_ORGANIZATION,
            variables: {
              organization: organizationJson,
            },
          });

          if (result.data.addOrUpdateOrganization) {
            this.errorText = '';
            this.$router.push({ path: '/organizations' });
          }

          this.errorText = 'Something went wrong with the database connection';
        } catch (err) {
          this.errorText = err.message;
          console.log('Error adding/updating organization! ' + err.message);
        }
      },
      imageAction() {
        if (this.hasImage) {
          //Delete image
          this.image = null;
          this.imageFile = null;
        } else {
          //Add image
          document.getElementById('imageInput').click();
        }
      },
      async onFileChange(file) {
        if (!file) {
          return;
        }
        this.image = await toBase64(file);
      },
    },
  };
</script>

<style scoped>
  @media only screen and (max-width: 800px) {
    #imageRow {
      width: 100%;
    }
  }

  @media only screen and (min-width: 800px) {
    #imageRow {
      width: 400px;
    }
  }
</style>
